import Icon from '@ant-design/icons';
import * as React from 'react';

const ReceivablesSvg = (props: any) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_179525_1768)">
            <path d="M0.615479 6.2757H15.3847V15.3846H0.615479V6.2757Z" stroke="black" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15.3847 12.5797C14.6408 12.5797 13.9274 12.8752 13.4013 13.4012C12.8753 13.9273 12.5798 14.6407 12.5798 15.3846M12.5798 6.2757C12.5798 7.01961 12.8753 7.73305 13.4013 8.25908C13.9274 8.7851 14.6408 9.08062 15.3847 9.08062M0.615479 9.08062C0.983826 9.08062 1.34857 9.00807 1.68888 8.86711C2.02919 8.72615 2.3384 8.51954 2.59886 8.25908C2.85932 7.99861 3.06593 7.6894 3.20689 7.34909C3.34785 7.00878 3.4204 6.64404 3.4204 6.2757M3.4204 15.3846C3.4204 15.0163 3.34785 14.6515 3.20689 14.3112C3.06593 13.9709 2.85932 13.6617 2.59886 13.4012C2.3384 13.1408 2.02919 12.9342 1.68888 12.7932C1.34857 12.6522 0.983826 12.5797 0.615479 12.5797" stroke="black" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.00012 14.0683C9.7885 14.0683 11.2383 12.6185 11.2383 10.8302C11.2383 9.04178 9.7885 7.59201 8.00012 7.59201C6.21173 7.59201 4.76196 9.04178 4.76196 10.8302C4.76196 12.6185 6.21173 14.0683 8.00012 14.0683Z" stroke="black" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M7.99994 4.73723V0.615387M9.33532 3.39939L7.99994 4.73785L6.66455 3.39939" stroke="black" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_179525_1768">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>

);

export const ReceivablesIcon = (props: any) => (
    <Icon component={(innerProps: any) => {
        return ReceivablesSvg({ ...innerProps, ...props });
    }}
    />
);
